export default "__VITE_ASSET__ce3bfb75__"